import { ReviewsTrackOption } from "../../types/requestsOutputs";

export interface BuildReviewsTrackIdsPayloadArgs {
    isOwner: boolean;
    showCompanyFilter: boolean;
    selectedCompanyIds: string[];
    selectedTrackIds: string[];
    tracksForPicker: ReviewsTrackOption[];
}

/**
 * Resolves which `trackIds` to POST to `/get-reviews` / export so it matches
 * UI scope. Empty company multiselect = all companies (owner). Returns `null`
 * only when companies are narrowed but no track matches (empty scope).
 */
export function buildReviewsTrackIdsPayload(a: BuildReviewsTrackIdsPayloadArgs): string[] | null {
    const picked = a.selectedTrackIds.filter((id) => a.tracksForPicker.some((t) => t.id === id));

    if (!a.isOwner) {
        return picked.length > 0
            ? Array.from(new Set(picked))
            : Array.from(new Set(a.tracksForPicker.map((t) => t.id)));
    }

    if (!a.showCompanyFilter) {
        return picked.length > 0 ? Array.from(new Set(picked)) : [];
    }

    if (a.selectedCompanyIds.length === 0) {
        return picked.length > 0 ? Array.from(new Set(picked)) : [];
    }

    if (picked.length > 0) {
        return Array.from(new Set(picked));
    }

    const all = a.tracksForPicker.map((t) => t.id);
    return all.length > 0 ? Array.from(new Set(all)) : null;
}
